// extracted by mini-css-extract-plugin
export default {"root":"StepIndicator_root__Tp0Ib","step":"StepIndicator_step__KKuR9"};